import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface FiltroItem {
  id: number;
  descricao: string;
}

interface ModalFiltrosData {
  categorias: FiltroItem[];
  tags: FiltroItem[];
  situacoes: string[];
  selecionados?: {
    idsCategorias: number[];
    idsTags: number[];
    situacoes: string[];
  };
}

export interface ModalFiltrosResult {
  idsCategorias: number[];
  idsTags: number[];
  situacoes: string[];
}

@Component({
  selector: 'app-modal-filtros',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './modal-filtros.component.html',
  styleUrls: ['./modal-filtros.component.css'],
})
export class ModalFiltrosComponent {
  public categorias: FiltroItem[] = [];
  public tags: FiltroItem[] = [];
  public situacoes: string[] = [];
  public categoriasCtrl = new FormControl<number[]>([]);
  public tagsCtrl = new FormControl<number[]>([]);
  public situacaoCtrl = new FormControl<string | null>(null);

  constructor(
    public dialogRef: MatDialogRef<ModalFiltrosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalFiltrosData
  ) {
    this.categorias = data?.categorias || [];
    this.tags = data?.tags || [];
    this.situacoes = data?.situacoes || [];
    this.categoriasCtrl.setValue(data?.selecionados?.idsCategorias || []);
    this.tagsCtrl.setValue(data?.selecionados?.idsTags || []);
    this.situacaoCtrl.setValue(data?.selecionados?.situacoes?.[0] || null);
  }

  public limpar(): void {
    this.categoriasCtrl.setValue([]);
    this.tagsCtrl.setValue([]);
    this.situacaoCtrl.setValue(null);
  }

  public getSituacaoLabel(situacao: string): string {
    switch (situacao) {
      case 'conciliado':
        return 'Conciliado';
      case 'naoConciliado':
        return 'Não Conciliado';
      default:
        return situacao;
    }
  }

  public aplicar(): void {
    const result: ModalFiltrosResult = {
      idsCategorias: this.categoriasCtrl.value || [],
      idsTags: this.tagsCtrl.value || [],
      situacoes: this.situacaoCtrl.value ? [this.situacaoCtrl.value] : [],
    };
    this.dialogRef.close(result);
  }
}
